import React from 'react';
import { Button, Menu } from '@oliasoft-open-source/react-ui-library';
import { getTokenPayload } from '@oliasoft/pkce';
import { AccessSubjectTypes } from '@oliasoft/hierarchy-gui';
import type { IAccessControlModalsRef, IUser } from '@oliasoft/hierarchy-gui';

import translations from 'src/internationalisation/translation-map.json';
import ClientConfig from '../../config/config';
import { THierarchyEntityWithType } from '../interfaces/hierarchy.interfaces';

interface GetAccessControlMenuParams {
  t: (key: string) => string;
  item: THierarchyEntityWithType | any;
  accessControlChildRef: React.RefObject<IAccessControlModalsRef | null>;
  users: IUser[];
  apiKeys?: string[];
  getEntityAccessRightsList: (id: string, type: string, subjectType: AccessSubjectTypes) => void;
}

interface MakeAccessControlOptionParams extends GetAccessControlMenuParams {
  subjectType?: AccessSubjectTypes;
  icon?: 'key' | 'lock';
}

export const makeAccessControlOption = ({
  t,
  item,
  subjectType = AccessSubjectTypes.User,
  icon = 'key',
  accessControlChildRef,
  users,
  apiKeys,
  getEntityAccessRightsList,
}: MakeAccessControlOptionParams) => {
  const tokenPayload = getTokenPayload(
    ClientConfig.config.pkce.provider,
    ClientConfig.config.applicationId,
    ClientConfig.config.idpServerUrl,
  );

  return {
    icon,
    type: 'Option',
    label:
      subjectType === AccessSubjectTypes.User
        ? t(translations.accessControl_title)
        : t(translations.authorization_apiKeyAccessControl),
    onClick: () => {
      accessControlChildRef.current?.accessRightsConfigurationStarted({
        item,
        userList: users,
        apiKeyList: apiKeys,
        currentUserSubjectId: tokenPayload?.subjectId || '',
        subjectType,
      });
      getEntityAccessRightsList(item.id, item.entityType, subjectType);
    },
  };
};

export const getAccessControlMenu = ({
  t,
  item,
  accessControlChildRef,
  users,
  apiKeys,
  getEntityAccessRightsList,
}: GetAccessControlMenuParams) => {
  const sections = [
    makeAccessControlOption({
      t,
      item,
      subjectType: AccessSubjectTypes.User,
      icon: 'key',
      accessControlChildRef,
      users,
      apiKeys,
      getEntityAccessRightsList,
    }),
  ];

  return (
    <Menu
      menu={{
        sections,
        trigger: 'Component',
        component: <Button small basic round colored="muted" icon="menu" />,
      }}
    />
  );
};
